module.exports = __webpack_public_path__ + "media/images/front/favicon_admin-a5173ae3060c32feb5cf019a3ef056ba.ico";